import React from "react";
import { useSelector } from "react-redux";
import MeetingsParent from "./parent/MeetingsParent";

import MeetingsTeacher from "./teacher/MeetingsTeacher";
import MeetingsStudent from "./student/MeetingsStudent";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
const Meetings = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_teacher) {
      return <MeetingsTeacher />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <MeetingsParent />;
      }
      return <Loader />;
    }
    if (state.auth.user.is_student) {
      return <MeetingsStudent />;
    }
    return <PermissionDenied />;
  }
};

export default Meetings;
